import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import DataProvider from '../../../app/data-framework/data-provider';
import templateMarkup from 'raw-loader!./widget-header.html';
import CommonDialog from '../../modal-dialog/common-dialog/common-dialog';
import PermissionService from '../../../services/permission.service';
import '../../../app/bindings/ko-bindinghandler-htmlSafe';
import LoginService from "../../../services/login.service";

function WidgetHeader(params) {

    var self = this;

    self.params = params.params;
    self.widgetSignals = params.widgetSignals;
    self.panelTemplate = self.params.panelTemplate;
    self.observableOptions = self.params.observableOptions;
    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);
    self.panelType = self.params.panelTemplate.panelType;
    self.panelId = 'panel-container-' + self.observableOptions().id;
    self.panelEl = document.getElementById(self.panelId);
    self.dashboardsAndTabsList = params.dashboardsAndTabsList;
    self.selectedTab = params.selectedTab;
    self.viewId = params.viewId;

    self.fixedPanel = self.params.panelTemplate.fixedPanel;

    self.hideHeader = ko.computed({
        read: function () {
            return self.fixedPanel || !!self.params.panelTemplate.hideHeader;
        },
        write: _.noop
    }, self);
    self.hideControls = ko.computed({
        read: function () {
            return self.fixedPanel || !!self.params.panelTemplate.hideControls;
        },
        write: _.noop
    }, self);

    self.allowExport = params.allowExport || ko.observable(true);

    var panelTemplate = self.params.panelTemplate;

    self.hasOptionsPanel = !($.isEmptyObject(panelTemplate.optionsComp));

    self.optionsLink = "<i class='fa fa-cog'></i>";

    if (self.hasOptionsPanel && panelTemplate.optionsLink) {
        self.optionsLink = panelTemplate.optionsLink;
    }

    self.header = ko.computed({
        read: function() {
            return self.observableOptions().panelHeader || self.panelTemplate.header;
        },
        write: function(newValue) {
            var options = self.params.observableOptions();
            options.panelHeader = newValue;
            self.params.observableOptions(options);
            if (self.widgetSignals().titleSignal) {
                self.widgetSignals().titleSignal.dispatch(options);
            }
        }
    });

    self.subscriptions = [];

    self.allowAddToDashboard = panelTemplate.allowAddToDashboard !== false; // allow by default

    var url = window.location.href;
    if (_.includes(url, 'historical/dashboard') || _.includes(url, '#historical2') ) {
        self.allowAddToDashboard = false;
    }

    self.addPanelToDashboard = function () {
    };

    self.addPanelToDashboardTab = function (data) {
        if (self.params.copyPanelSignal) {
            self.params.copyPanelSignal.dispatch(self.observableOptions().id, data);
        }
    };

    self.showDisplaySelection = function() {
      return this.panelType === 'Distribution'
          || this.panelType === 'SummaryPanel'
          || this.panelType === 'Trend';
    };

    // hide submenus when dropdown is hidden
    $(self.panelEl).find('div.dropdown').first().on('hidden.bs.dropdown', function(e) {
      if (self.submenuEl) {
        self.submenuEl.classList.remove('show');
      }
    });
}

WidgetHeader.prototype.isActiveTab = function(dashboardAndTabsListViewId, tabId) {
    return dashboardAndTabsListViewId === this.viewId || (this.selectedTab() && tabId === this.selectedTab().id);
};

WidgetHeader.prototype.openOptionsModal = function () {
    var self = this;

    if (self.widgetSignals) {
        // self.widgetSignals().optionsPanelToggle.dispatch();
        self.widgetSignals().optionsPanelOpen.dispatch();
    }
};

WidgetHeader.prototype.onTitleKeyPress = function(element, event) {
    if (event.keyCode === 13) {
        event.target.blur();
    }
    return true;
};

WidgetHeader.prototype.delete_widget = function () {
    var self = this;

    CommonDialog.confirm('Are you sure you want to delete this panel?').then(function(confirmed) {
        if (confirmed) {
            self.params.deletedSignal.dispatch(self.observableOptions().id);
        }
    });
};

WidgetHeader.prototype.clonePanel = function() {
  let self = this;
  if (self.widgetSignals().clonePanel) {
    self.widgetSignals().clonePanel.dispatch();
  }
}

WidgetHeader.prototype.movePanel = function(targetDashboard, targetTab) {
  let self = this;
  if (self.widgetSignals().movePanel) {
    self.widgetSignals().movePanel.dispatch(targetDashboard.viewId, targetTab, self.observableOptions().id);
  }
}

WidgetHeader.prototype.copyPanel = function() {
  let self = this;
  if (self.widgetSignals().copyPanel) {
    self.widgetSignals().copyPanel.dispatch();
  }
}

WidgetHeader.prototype.copyPanelAdvanced = function() {
  let self = this;
  if (self.widgetSignals().copyPanelAdvanced) {
    self.widgetSignals().copyPanelAdvanced.dispatch();
  }
}

WidgetHeader.prototype.toggleSubmenu = function(data, event) {
  let self = this;
  let submenu = getMatchingSibling(event.target, '.dropdown-menu');
  event.stopPropagation();

  if (!self.submenuEl) {
    self.submenuEl = submenu;
  }
  submenu.classList.toggle('show');

  function getMatchingSibling(el, selector) {
    let sibling = el.nextElementSibling;

    if (!selector) { return sibling }

    while (sibling) {
      if (sibling.matches(selector)) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }
  }
}


// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
WidgetHeader.prototype.dispose = function() {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

export default { viewModel: WidgetHeader, template: templateMarkup };
